import { ref, computed } from 'vue'

// we'll be loading events from the remote WP site
const _events = ref([])
const _event = ref([])
export const fetchingEventsFromWordpress = ref(false)

export const events = computed(() => {
	// events names may have html entities in them, so we'll decode them
	_events.value.forEach(event => {
		if( !event.title ) return null
		event.title = event.title.replace(/&#(\d+);/g, function(match, dec) {
			return String.fromCharCode(dec);
		});
	})
	return _events.value
})
export const event = computed(() => {
	if( !_event.value.title ) return null
	// event names may have html entities in them, so we'll decode them
	_event.value.title = _event.value.title.replace(/&#(\d+);/g, function(match, dec) {
		return String.fromCharCode(dec);
	});
	return _event.value
})

// handle pagination
const page = ref(1)
const perPage = ref(25)
const total = ref(0)
const totalPages = ref(0)

// we'll be querying start date and end date formatted as YYYY-MM-DD
const startDate = ref(null)
const endDate = ref(null)

export const fetchEventsFromWordpress = (past = false) => {
	fetchingEventsFromWordpress.value = true
	_events.value = []

	// set up a query url concatenator
	const query = new URLSearchParams()
	query.append('per_page', perPage.value)
	query.append('page', page.value)
	if( past ) {
		// set start date to 1000 years ago as YYYY-MM-DD from date()
		let date = new Date()
		date.setFullYear(date.getFullYear() - 1000)
		startDate.value = date.toISOString().split('T')[0]

		// set end date to now
		endDate.value = new Date().toISOString().split('T')[0]
		query.append('start_date', startDate.value)
		query.append('end_date', endDate.value)

		// set date descending
		query.append('order', 'desc')
		query.append('orderby', 'start_date')
	} else { // looking for future events
		// don't add date parameters - future dates are the default api mode
	}
	
	// return the axios so we can fetchEventsFromWordpress().then()
	return axios.get('/events/index-wordpress', {
		params: query,
	})
	.then(response => {
		_events.value = response.data.events
	})
	.finally(() => {
		fetchingEventsFromWordpress.value = false
	})
}

export const fetchEventFromWordpress = (id) => {
	fetchingEventsFromWordpress.value = true

	// return the axios so we can fetchEventFromWordpress().then()
	return axios.get('/events/show-wordpress/' + id)
	.then(response => {
		_event.value = response.data
	})
	.finally(() => {
		fetchingEventsFromWordpress.value = false
	})
}